<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
  <span *ngIf="$.row && $.adata.fetch_key">{{ 'common.LANGUAGE.' + getLanguageName($.row[$.adata.fetch_key]).toUpperCase() | translate }} </span>
  </ng-container>
  